import React, { useRef, useState } from "react";
import { CondicionPago } from "models/ECF/CondicionPago";
import { CondicionPagoManager } from "managers";
import useMessage from "hooks/useMessage";
import useExceptionHandler from "hooks/useExceptionHandler";
import { Simplebar } from "components/Simplebar/Simplebar";
import CondicionPagoEdit from "./CondicionPagoEdit";

const DEFAULT_VALUES = {
  Descripcion: "",
  Dias: 0,
  Estatus: CondicionPago.ESTATUS_ACTIVO,
};

export default function CondicionPagoEditCanvas({
  showCanvas,
  setShowCanvas,
  showLoading,
  hideLoading,
  updateList = () => {},
}) {
  const ref = useRef(null);
  const { Message } = useMessage();
  const { handleException } = useExceptionHandler();
  const [condicionPago, setCondicionPago] = useState(DEFAULT_VALUES);

  function grabar() {
    showLoading();
    CondicionPagoManager.crear(condicionPago)
      .then(() => {
        Message({ message: "Grabado Exitosamente" });
        setCondicionPago(DEFAULT_VALUES);
        setShowCanvas(false);
      })
      .catch((e) => handleException(e))
      .finally(() => {
        hideLoading();
        updateList();
      });
  }

  return (
    <Simplebar
      ref={ref}
      backdrop="static"
      confirmBack
      placement="end"
      portal={false}
      visible={showCanvas}
      setShow={(e) => setShowCanvas(e)}
      useLoading={true}
      title="Crear Condición de Pago"
      btnLeft={{
        show: true,
        message: "Grabar",
        isComponent: true,
        size: "45px",
        height: "24px",
        with: "24px",
        iconName: "save",
        isCenter: true,
        func: grabar,
      }}
      btnRight={{ show: false, label: "Grabar", func: () => {} }}
    >
      <CondicionPagoEdit
        condicionPago={condicionPago}
        setCondicionPago={setCondicionPago}
      />
    </Simplebar>
  );
}
